module.exports = __webpack_public_path__ + "img/07.0f8dfccd.png";